













import { Component, Vue } from 'vue-property-decorator'

import Breadcrumbs, { BreadcrumbsItem } from '@/components/lib/Breadcrumbs.vue'
import Mir from '@/components/layouts/Mir.vue'

@Component({
  components: {
    Mir,
    Breadcrumbs,
  },
})
class LoyaltyView extends Vue {
  breadcrumbsItems: Array<BreadcrumbsItem> = [
    {
      text: 'Сервисы',
      disabled: false,
      to: { name: 'main/maintenances' },
    },
    {
      text: this.$route.meta.title,
      disabled: true,
    },
  ]
}

export default LoyaltyView
